(function ($) {
  Drupal.behaviors.productQtyV1 = {
    attach: function (context, settings) {
      var $addToBag = $('.product-full .btn-add-to-bag', context);
      var $qtyValue = $('.btn-qty__value', context);
      var $qtyAdd = $('.btn-qty__add', context);
      var $qtySubtract = $('.btn-qty__subtract', context);

      $qtyAdd.once().on('click', function () {
        var qty = parseInt($qtyValue.html());

        if (qty < 6) {
          $qtyValue.html(qty + 1);
          $addToBag.data('qty', $qtyValue.html());
        }
      });

      $qtySubtract.once().on('click', function () {
        var qty = parseInt($qtyValue.html());

        if (qty > 1) {
          $qtyValue.html(qty - 1);
          $addToBag.data('qty', $qtyValue.html());
        }
      });
    }
  };
})(jQuery);
